import { render, staticRenderFns } from "./JobDetailViewHistoryInfo.vue?vue&type=template&id=e2577cb6&"
import script from "./JobDetailViewHistoryInfo.vue?vue&type=script&lang=js&"
export * from "./JobDetailViewHistoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports